// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.more-less-button_26999359 {
  white-space: nowrap;
  display: inline;
  vertical-align: baseline;
}
.more-less-button_horizontal_26999359 {
  padding-left: 0.667rem;
}
.more-less-button_vertical_26999359 {
  padding-top: 0.667rem;
  display: block;
}
.more-less-button_26999359 i {
  position: relative;
  vertical-align: -1px;
}
.more-less-button__caption_26999359::after {
  content: '\\00a0';
}
.more-less-button__caption_less_26999359::after {
  display: none;
}
.more-less-button_26999359 .more-less-button__caption_text_26999359::before,
.more-less-button_26999359 .more-less-button__caption_less_26999359::before {
  content: '\\00a0';
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"more-less-button": `more-less-button_26999359`,
	"more-less-button_horizontal": `more-less-button_horizontal_26999359`,
	"more-less-button_vertical": `more-less-button_vertical_26999359`,
	"more-less-button__caption": `more-less-button__caption_26999359`,
	"more-less-button__caption_less": `more-less-button__caption_less_26999359`,
	"more-less-button__caption_text": `more-less-button__caption_text_26999359`
};
export default ___CSS_LOADER_EXPORT___;
